// View `focus` on the TABULAR surfaces (table / grid / cards / matrix).
//
// The board's ground veil is a rect drawn over the item; a row, a chip or a
// matrix band has an opaque surface behind it and nothing drawn on top, so
// occluding it and scaling its alpha are the same pixels — `opacity` with the
// same factor the veil leaves through (`FOCUS_GROUND_ALPHA`). Same channel,
// same number, one visual vocabulary across every surface (design-language #9).
//
// Focus never reorders and never filters. The ground stays legible and in
// place: an author who wanted it gone had `hide`.

import { FOCUS_GROUND_ALPHA } from "@archlang/scene/board";

/**
 * Props for one row / chip / cell, given the view's focus set and this
 * element's ORIGIN-QUALIFIED key — the space both `plan.focus` and every
 * tabular `key` field live in.
 *
 * Returns an empty object when the view focuses nothing, so an unfocused
 * surface renders exactly as before.
 */
export function groundProps(
  focus: ReadonlySet<string> | undefined,
  key: string,
): { readonly style?: { readonly opacity: number }; readonly "data-focus"?: "ground" } {
  if (!focus || focus.size === 0 || focus.has(key)) return {};
  return { style: { opacity: FOCUS_GROUND_ALPHA }, "data-focus": "ground" };
}

/** True when this key is GROUND under the given focus set. */
export function isGround(focus: ReadonlySet<string> | undefined, key: string): boolean {
  return !!focus && focus.size > 0 && !focus.has(key);
}
